import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface BannerState {
    message: string | null;
    isVisible: boolean;
}

const initialState: BannerState = {
    message: localStorage.getItem("banner_message") ?? null,
    isVisible: !!localStorage.getItem("banner_message"),
};

export const bannerSlice = createSlice({
    name: "banner",
    initialState,
    reducers: {
        showBanner: (state, action: PayloadAction<{ message: string }>) => {
            state.message = action.payload.message;
            state.isVisible = true;
        },
        hideBanner: (state) => {
            state.isVisible = false;
            state.message = null;
        },
    },
});

export const { showBanner, hideBanner } = bannerSlice.actions;

export default bannerSlice.reducer;
